import { Drawer, Typography, Space, Tag, Image } from 'antd'
import styled from 'styled-components'
import { IconFont, TagDetail, BaseDrawer } from '@/components'
import { useGetCaseDetail, useAttackTypeList } from './utils'
import { useEffect } from 'react'
import moment from 'moment'
import leakSeverity from '@/assets/imges/leak-severity.png'
import leakCenter from '@/assets/imges/leak-center.png'
import leakLow from '@/assets/imges/leak-low.png'
import leakHigh from '@/assets/imges/leak-high.png'
interface CaseDetailProps {
  visible: boolean
  onClose: () => void
  resourceId: string
  attackTypeList: any[]
}

export const CaseDetail = ({ visible, onClose, resourceId, attackTypeList }: CaseDetailProps) => {
  const { Text } = Typography
  const [detail, getCaseDetail, loading] = useGetCaseDetail()
  useEffect(() => {
    if (visible) {
      getCaseDetail({ resourceId }).catch(_ => {})
    }
  }, [visible])

  const renderLabel = (label: string) => (
    <Text className="label" type="secondary">
      {label}：
    </Text>
  )

  const riskLevelMap = {
    RiskLevelLow: { label: t('低危'), class: 'leak-low', icon: <Image src={leakLow} width={19} /> },
    RiskLevelMiddle: {
      label: t('中危'),
      class: 'leak-center',
      icon: <Image src={leakCenter} width={19} />,
    },
    RiskLevelHigh: {
      label: t('高危'),
      class: 'leak-high',
      icon: <Image src={leakHigh} width={19} />,
    },
    RiskLevelGross: {
      label: t('严重'),
      class: 'leak-severity',
      icon: <Image src={leakSeverity} width={19} />,
    },
  }

  const resourceLevelMap = {
    ResourceLevelJunior: { label: t('初级'), class: 'resource-level-junior' },
    ResourceLevelMiddle: { label: t('中级'), class: 'resource-level-middle' },
    ResourceLevelSenior: { label: t('高级'), class: 'resource-level-senior' },
  }

  return (
    <BaseDrawer title={t('详情')} onClose={onClose} open={visible} props={{ width: 560 }}>
      <Container>
        <div className="content">
          <div className="item">
            {renderLabel(t('用例名称'))}
            <Text className="content">{detail?.baseDetail?.name}</Text>
          </div>

          <div className="item">
            {renderLabel(t('验证模式'))}
            <Text className="content">
              {detail?.baseDetail?.verificationModeId === 2
                ? t('Web攻击机 → Web应用')
                : t('Web应用 → Web攻击机')}
            </Text>
          </div>

          {/* <div className="item">
          {renderLabel('拦截状态')}
          <Text className="content">{detail?.baseDetail?.status}</Text>
        </div> */}

          <div className="item">
            {renderLabel(t('危险等级'))}
            <span>
              {riskLevelMap[detail?.baseDetail?.riskLevel]?.icon}
              <span className={riskLevelMap[detail?.baseDetail?.riskLevel]?.class}>
                {riskLevelMap[detail?.baseDetail?.riskLevel]?.label}
              </span>
            </span>
          </div>

          <div className="item">
            {renderLabel(t('用例分级'))}
            <span className={resourceLevelMap[detail?.baseDetail?.resourceLevel]?.class}>
              {resourceLevelMap[detail?.baseDetail?.resourceLevel]?.label}
            </span>
          </div>

          <div className="item">
            {renderLabel(t('攻击类型'))}
            <Text className="content">
              {attackTypeList?.filter(item => item.id === detail?.baseDetail?.attackTypeId)?.[0]
                ?.name || '-'}
            </Text>
          </div>

          <div className="item" style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
            {renderLabel(t('漏洞编号'))}
            <Text
              className="content"
              style={{ display: 'flex', flexDirection: 'column', flexWrap: 'wrap' }}
            >
              {detail?.payloadDetail?.cveId &&
                Object.keys(detail?.payloadDetail?.cveId)?.map((key, index) => (
                  <>
                    <a
                      href={detail?.payloadDetail?.cveId[key]}
                      target="_blank"
                      rel="noopener noreferrer"
                      key={index}
                    >
                      {key}
                    </a>
                    {/* {index + 1 === Object.keys(detail?.payloadDetail?.cveId)?.length ? '' : ', '} */}
                  </>
                ))}
              {detail?.payloadDetail?.cnvdId?.map((item, index) => (
                <div style={{ marginTop: 5 }}>
                  <span key={index}>{item}</span>
                </div>
              ))}
              {detail?.payloadDetail?.cnnvdId?.map((item, index) => (
                <div style={{ marginTop: 5 }}>
                  <span key={index}>{item}</span>
                </div>
              ))}
            </Text>
          </div>

          {detail?.payloadDetail?.tactics?.length > 0 && (
            <div className="item" style={{ display: 'flex', flexDirection: 'column' }}>
              {renderLabel('ATT&CK')}
              <div style={{ background: '#F8F9FB', padding: 10, borderRadius: 8, marginTop: 14 }}>
                {detail?.payloadDetail?.tactics?.map((info, index) => (
                  <Text
                    key={index}
                    className="content"
                    style={{ display: 'block', marginBottom: 5 }}
                  >
                    {info.name}
                  </Text>
                ))}
              </div>
            </div>
          )}

          <div className="item">
            {renderLabel(t('更新时间'))}
            <Text className="content">
              {detail?.payloadDetail?.updateTime
                ? moment(detail?.payloadDetail?.updateTime).format('YYYY-MM-DD HH:mm:ss')
                : '-'}
            </Text>
          </div>

          <div className="item">
            {detail?.payloadDetail?.resourceTagList &&
              detail?.payloadDetail?.resourceTagList?.length > 0 && (
                <TagDetail resourceTagList={detail?.payloadDetail?.resourceTagList} />
              )}
          </div>

          <div className="item">
            {renderLabel('OWASP TOP10')}
            <Text className="content">{detail?.payloadDetail?.owasp || '-'}</Text>
          </div>

          <div className="item">
            {renderLabel('WASC')}
            <Text className="content">{detail?.payloadDetail?.wasc || '-'}</Text>
          </div>

          <div className="item">
            {renderLabel(t('操作系统'))}
            <Text className="content">{detail?.payloadDetail?.os?.name || '-'}</Text>
          </div>

          <div className="item">
            {renderLabel(t('数据库'))}
            <Text className="content">{detail?.payloadDetail?.db?.name || '-'}</Text>
          </div>

          <div className="item">
            {renderLabel(t('开发语言'))}
            <Text className="content">{detail?.payloadDetail?.language?.name || '-'}</Text>
          </div>

          <div className="item">
            {renderLabel(t('影响组件'))}
            <Text className="content">{detail?.payloadDetail?.component?.name || '-'}</Text>
          </div>

          <div className="item">
            {renderLabel(t('WAF厂商'))}
            <Text className="content">{detail?.payloadDetail?.wafFirm || '-'}</Text>
          </div>

          <div className="item">
            {renderLabel(t('描述'))}
            <div className="description">{detail?.payloadDetail?.describe || '-'}</div>
          </div>

          <div className="item">
            {renderLabel(t('解决方案'))}
            <div className="description">{detail?.payloadDetail?.solution || '-'}</div>
          </div>
        </div>
      </Container>
    </BaseDrawer>
  )
}

const Container = styled.div`
  .content {
    .item {
      margin-bottom: 24px;

      .label {
        display: inline-block;
        width: 100px;
        color: #86909c;
        font-size: 14px;
      }

      .content {
        color: #333;
        font-size: 14px;
      }
    }

    .description {
      margin-top: 8px;
      padding: 16px 12px;
      background: #f8f9fb;
      border-radius: 8px;
      min-height: 80px;
      white-space: pre-wrap;
      word-break: break-all;
    }
  }
  .leak-low {
    display: inline-block;
    width: 36px;
    height: 16px;
    background: #e1ebfe;
    color: #6f9fff;
    border-radius: 4px;
    margin-left: 10px;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
  }

  .leak-center {
    display: inline-block;
    width: 36px;
    height: 16px;
    background: #ffedce;
    color: #ffa709;
    border-radius: 4px;
    margin-left: 10px;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
  }

  .leak-high {
    display: inline-block;
    width: 36px;
    height: 16px;
    background: #ffe1e1;
    color: #ff4141;
    border-radius: 4px;
    margin-left: 10px;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
  }

  .leak-severity {
    display: inline-block;
    width: 36px;
    height: 16px;
    background: #f5d9d9;
    color: #b70000;
    border-radius: 4px;
    margin-left: 10px;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
  }
  .resource-level-junior {
    display: inline-block;
    background: #6f9fff;
    color: #fff;
    border-radius: 4px;
    font-size: 12px;
    width: 36px;
    height: 16px;
    line-height: 16px;
    text-align: center;
  }
  .resource-level-middle {
    display: inline-block;
    background: #ffa709;
    color: #fff;
    border-radius: 4px;
    font-size: 12px;
    width: 36px;
    height: 16px;
    line-height: 16px;
    text-align: center;
  }
  .resource-level-senior {
    display: inline-block;
    background: #f44f4f;
    color: #fff;
    border-radius: 4px;
    font-size: 12px;
    width: 36px;
    height: 16px;
    line-height: 16px;
    text-align: center;
  }
`

export default CaseDetail
